import React, { useState, useEffect } from 'react';
import { getImageUrl, getStudentPhotoUrl, getCompanyLogoUrl } from '../utils/imageUtils';
import axios from "axios";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Autosuggest from "react-autosuggest";
import { useParams, useLocation } from "react-router-dom";
import moment from "moment";

export default function PrintSt() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { http, user } = AuthUser();
    // KT4191 GRACE INSTITUTIONS — hide Section/Division on receipt
    const hideSectionOnReceipt = Number(user?.company_id) === 11;
    const [usersjob, setUsersJob] = useState([]);
    const [loading, setLoading] = useState(true);
    const [companylogo, setCompanylogo] = useState();
    const [companyname, setCompanyname] = useState();
    const [companyaddr, setCompanyaddr] = useState();
    const [isReceipt, setIsReceipt] = useState(0); // Company's is_receipt flag
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const num = queryParams.get('num');
    
    // Add state for fee data and due amounts
    const [feeData, setFeeData] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalPaid, setTotalPaid] = useState(0);
    const [totalDue, setTotalDue] = useState(0);
    const [studentData, setStudentData] = useState(null);

    // Simple professional styles for print
    const printStyles = `
        <style>
        @import url('https://fonts.googleapis.com/css2?family=Arial:wght@400;500;600;700&display=swap');
        
        .print-container {
            font-family: Arial, sans-serif;
            max-width: 250mm;
            margin: 0 auto;
            padding: 20px;
            background: white;
            color: #000;
        }
        
        .receipt-header {
            border-bottom: 2px solid #000;
            padding-bottom: 20px;
            margin-bottom: 20px;
        }
        
        .company-info {
            text-align: center;
        }
        
        .company-name {
            font-size: 28px;
            font-weight: bold;
            margin: 10px 0;
            text-transform: uppercase;
            ${user.company_id === 40 ? 'font-family: Bookman Old Style; color: #090002;' : ''}
        }
        
        .company-address {
            font-size: 14px;
            margin-bottom: 10px;
        }
        
        .receipt-title {
            background: #f0f0f0;
            text-align: center;
            padding: 5px;
            font-size: 18px;
            font-weight: bold;
            margin: 20px 0;
            border: 1px solid #000;
            ${user.company_id === 40 ? 'font-family: Bookman Old Style; color: #090002;' : ''}
        }
        
        .receipt-title div {
            line-height: 1.4;
        }
        
        .receipt-title div:first-child {
            font-size: 16px;
        }
        
        .receipt-title div:last-child {
            font-size: 20px;
        }
        
        .student-info {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }
        
        .info-section {
            flex: 1;
            padding: 0 15px;
        }
        
        .info-row {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            border-bottom: 1px dotted #ccc;
            padding-bottom: 5px;
        }
        
        .info-label {
            font-weight: bold;
            width: 140px;
            flex-shrink: 0;
        }
        
        .info-value {
            flex: 1;
            padding-left: 10px;
        }
        
        .receipt-number {
            font-weight: 600;
            font-size: 16.5px;
            font-family: 'Segoe UI', Arial, sans-serif;
            color: #000;
        }
        
        .student-photo {
            width: 100px;
            height: 120px;
            border: 2px solid #000;
            object-fit: cover;
        }
        
        .fees-table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
        }
        
        .fees-table th,
        .fees-table td {
            border: 1px solid #000;
            padding: 10px;
            text-align: left;
        }
        
        .fees-table th {
            background: #f0f0f0;
            font-weight: bold;
            text-align: center;
        }
        
        .fees-table .total-row {
            background: #f0f0f0;
            font-weight: bold;
        }
        
        .signature-section {
            margin-top: 40px;
            display: flex;
            justify-content: space-between;
        }
        
        .signature-box {
            text-align: center;
            width: 280px;
        }
        
        .signature-line {
            border-bottom: 1px solid #000;
            margin: 30px 0 10px 0;
        }
        
        .note-section {
            margin-top: 30px;
            padding: 15px;
            border: 1px solid #000;
            font-size: 12px;
            font-style: italic;
        }
        

        
        .print-buttons {
            text-align: center;
            margin-bottom: 20px;
        }
        
        .print-btn {
            background: #007bff;
            color: white;
            border: none;
            padding: 10px 20px;
            margin: 0 10px;
            border-radius: 5px;
            cursor: pointer;
            font-size: 14px;
        }
        
        .print-btn:hover {
            background: #0056b3;
        }
        
        @media print {
            .print-buttons {
                display: none !important;
            }
            .print-container {
                max-width: none;
                margin: 0;
                padding: 10px;
                box-shadow: none;
                page-break-inside: avoid;
                page-break-after: avoid;
            }
            body {
                margin: 0;
                padding: 0;
                font-size: 12px;
            }
            .receipt-header {
                padding-bottom: 10px;
                margin-bottom: 10px;
            }
            .company-name {
                font-size: 18px;
                margin: 5px 0;
                ${user.company_id === 40 ? 'font-family: Bookman Old Style; color: #090002;' : ''}
            }
            .company-address {
                font-size: 11px;
                margin-bottom: 5px;
            }
            .receipt-title {
                padding: 5px;
                font-size: 14px;
                margin: 10px 0;
                ${user.company_id === 40 ? 'font-family: Bookman Old Style; color: #090002;' : ''}
            }
            .student-info {
                margin-bottom: 10px;
            }
            .info-row {
                margin-bottom: 4px;
                padding-bottom: 2px;
            }
            .info-label {
                width: 120px;
                font-size: 11px;
            }
            .info-value {
                font-size: 11px;
            }
            .student-photo {
                width: 80px;
                height: 100px;
            }
            .fees-table {
                margin: 10px 0;
                font-size: 10px;
            }
            .fees-table th,
            .fees-table td {
                padding: 6px;
            }
            .signature-section {
                margin-top: 20px;
            }
            .signature-box {
                width: 240px;
            }
            .signature-line {
                margin: 20px 0 5px 0;
            }
            .note-section {
                margin-top: 15px;
                padding: 8px;
                font-size: 10px;
            }

            .receipt-number {
                background: none;
                border: none;
                padding: 0;
                color: #000;
            }
            @page {
                margin: 10mm;
                size: A4;
            }
        }
        
        @media screen {
            .print-container {
                box-shadow: 0 0 10px rgba(0,0,0,0.1);
                margin: 20px auto;
            }
        }
        </style>
    `;

    // Function to fetch fee details similar to BillList.js
    const fetchFeeDetails = async (studentId) => {
        try {
            const response = await http.get(`/feeslist?student_id=${studentId}`);
            if (Array.isArray(response.data.data)) {
                setFeeData(response.data.data);
                
                // Calculate totals
                const amountSum = response.data.data.reduce((sum, task) => sum + (parseFloat(task.amount) || 0), 0);
                const paidSum = response.data.data.reduce((sum, task) => sum + (parseFloat(task.ext_6) || 0), 0);
                const dueSum = amountSum - paidSum;

                setTotalAmount(amountSum);
                setTotalPaid(paidSum);
                setTotalDue(dueSum);
            }
        } catch (error) {
            console.error("Error fetching fee details:", error);
        }
    };

    // Function to fetch student data
    const fetchStudentData = async (studentId) => {
        try {
            const response = await http.get(`/student_marks?&id=${studentId}&company_id=${user.company_id}`);
            if (response.data.data && response.data.data.length > 0) {
                setStudentData(response.data.data[0]);
            }
        } catch (error) {
            console.error("Error fetching student data:", error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await http.get(`/school_job_ind_print?&id=${id}`);
                setTimeout(() => {
                    setUsersJob(response.data.data);
                    
                    // If we have user data, fetch fee details and student data
                    if (response.data.data && response.data.data.length > 0) {
                        const studentId = response.data.data[0].student_id;
                        if (studentId) {
                            fetchFeeDetails(studentId);
                            fetchStudentData(studentId);
                        }
                    }
                    
                    setLoading(false);
                }, 700);
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false);
            }

            await http.get(`/companyinfo?login_user=${user.id}`).then((resp) => {
                setCompanyname(resp.data.data[0].company_name);
                setCompanylogo(resp.data.data[0].company_logo);
                setCompanyaddr(resp.data.data[0].company_address);
                setIsReceipt(resp.data.data[0].is_receipt || 0);
            });
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <div style={{textAlign: 'center', padding: '50px'}}>
                <div>Loading...</div>
            </div>
        );
    }

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        const printContents = document.querySelector('.print-container').innerHTML;
        
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <title>Fee Receipt</title>
                    ${printStyles}
                </head>
                <body>
                    <div class="print-container">${printContents}</div>
                    <div style="page-break-before: always;"></div>
                    <div class="print-container">${printContents}</div>
                </body>
            </html>
        `);
        
        printWindow.document.close();
        printWindow.focus();
        
        printWindow.onafterprint = () => {
            printWindow.close();
        };
        
        printWindow.print();
    };

    const handlePrintSecond = () => {
        const printWindow = window.open('', '_blank');
        const printContents = document.querySelector('.print-container').innerHTML;
        
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <title>Fee Receipt</title>
                    ${printStyles}
                </head>
                <body>
                    <div class="print-container">${printContents}</div>
                </body>
            </html>
        `);
        
        printWindow.document.close();
        printWindow.focus();
        
        printWindow.onafterprint = () => {
            printWindow.close();
        };
        
        printWindow.print();
    };

    const handlePrintInOne = () => {
        const printWindow = window.open('', '_blank');
        const printContents = document.querySelector('.print-container').innerHTML;
        
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <title>Fee Receipt - Two Copies</title>
                    ${printStyles}
                    <style>
                        body {
                            margin: 0;
                            padding: 20px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            min-height: 100vh;
                            font-size: 16px;
                        }
                        .print-container {
                            transform: scale(0.95);
                            transform-origin: center;
                            margin: 15px auto;
                            page-break-inside: avoid;
                            width: 100%;
                            max-width: 280mm;
                        }
                        .print-container:first-child {
                            margin-bottom: 60px;
                        }
                        /* Enhanced font sizes for better visibility */
                        .print-container .company-name {
                            font-size: 35px !important;
                            ${user.company_id === 40 ? 'font-family: Bookman Old Style !important; color: #890015 !important;' : ''}
                        }
                        .print-container .company-address {
                            font-size: 18px !important;
                        }
                        .print-container .receipt-title {
                            font-size: 26px !important;
                            ${user.company_id === 40 ? 'font-family: Bookman Old Style !important; color: #890015 !important;' : ''}
                        }
                        .print-container .info-label {
                            font-size: 16px !important;
                            font-weight: bold !important;
                        }
                        .print-container .info-value {
                            font-size: 16px !important;
                        }
                        .print-container .receipt-number {
                            font-size: 20px !important;
                        }
                        .print-container .fees-table th {
                            font-size: 15px !important;
                            font-weight: bold !important;
                        }
                        .print-container .fees-table td {
                            font-size: 15px !important;
                        }
                        .print-container .signature-box {
                            font-size: 15px !important;
                        }
                        .print-container .note-section {
                            font-size: 14px !important;
                        }
                        @media print {
                            body {
                                margin: 0;
                                padding: 0;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: flex-start;
                                font-size: 14px;
                                width: 210mm;
                                min-height: 297mm;
                            }
                            .print-container {
                                transform: scale(0.85);
                                transform-origin: center top;
                                margin: 0 auto 15px auto;
                                width: 210mm;
                                max-width: 210mm;
                                display: block;
                                padding: 0;
                            }
                            .print-container:first-child {
                                margin-bottom: 40px;
                            }
                            /* Print-specific font sizes */
                            .print-container .company-name {
                                font-size: 28px !important;
                                ${user.company_id === 40 ? 'font-family: Bookman Old Style !important; color: #890015 !important;' : ''}
                            }
                            .print-container .company-address {
                                font-size: 16px !important;
                            }
                            .print-container .receipt-title {
                                font-size: 22px !important;
                                ${user.company_id === 40 ? 'font-family: Bookman Old Style !important; color: #890015 !important;' : ''}
                            }
                            .print-container .info-label,
                            .print-container .info-value {
                                font-size: 14px !important;
                            }
                            .print-container .receipt-number {
                                font-size: 18px !important;
                            }
                            .print-container .fees-table th,
                            .print-container .fees-table td {
                                font-size: 13px !important;
                            }
                            .print-container .signature-box {
                                font-size: 13px !important;
                            }
                            .print-container .note-section {
                                font-size: 12px !important;
                            }
                            @page {
                                margin: 3mm;
                                size: A4 portrait;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-container">${printContents}</div>
                    <div class="print-container">${printContents}</div>
                </body>
            </html>
        `);
        
        printWindow.document.close();
        printWindow.focus();
        
        printWindow.onafterprint = () => {
            printWindow.close();
        };
        
        printWindow.print();
    };

    const handlePrintTwoWithoutDue = () => {
        const printWindow = window.open('', '_blank');
        const printContents = document.querySelector('.print-container').innerHTML;
        
        // Remove the due amount section from the print content
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = printContents;
        
        // Find and remove the due amount section - look for the div containing "Provisional balance due"
        const dueAmountSection = tempDiv.querySelector('div[style*="marginTop: \'15px\'"]');
        if (dueAmountSection && dueAmountSection.textContent.includes('Provisional balance due')) {
            dueAmountSection.remove();
        }
        
        // Also try to find by the specific text content
        const allDivs = tempDiv.querySelectorAll('div');
        allDivs.forEach(div => {
            if (div.textContent.includes('Provisional balance due') || div.textContent.includes('Payment completed for selected fees')) {
                div.remove();
            }
        });
        
        const cleanPrintContents = tempDiv.innerHTML;
        
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <title>Fee Receipt - Two Copies (Without Due)</title>
                    ${printStyles}
                    <style>
                        body {
                            margin: 0;
                            padding: 20px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            min-height: 100vh;
                            font-size: 16px;
                        }
                        .print-container {
                            transform: scale(0.95);
                            transform-origin: center;
                            margin: 15px auto;
                            page-break-inside: avoid;
                            width: 100%;
                            max-width: 280mm;
                        }
                        .print-container:first-child {
                            margin-bottom: 60px;
                        }
                        /* Enhanced font sizes for better visibility */
                        .print-container .company-name {
                            font-size: 32px !important;
                            ${user.company_id === 40 ? 'font-family: Bookman Old Style !important; color: #890015 !important;' : ''}
                        }
                        .print-container .company-address {
                            font-size: 18px !important;
                        }
                        .print-container .receipt-title {
                            font-size: 26px !important;
                            ${user.company_id === 40 ? 'font-family: Bookman Old Style !important; color: #890015 !important;' : ''}
                        }
                        .print-container .info-label {
                            font-size: 16px !important;
                            font-weight: bold !important;
                        }
                        .print-container .info-value {
                            font-size: 16px !important;
                        }
                        .print-container .receipt-number {
                            font-size: 20px !important;
                        }
                        .print-container .fees-table th {
                            font-size: 15px !important;
                            font-weight: bold !important;
                        }
                        .print-container .fees-table td {
                            font-size: 15px !important;
                        }
                        .print-container .signature-box {
                            font-size: 15px !important;
                        }
                        .print-container .note-section {
                            font-size: 14px !important;
                        }
                        @media print {
                            body {
                                margin: 0;
                                padding: 0;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: flex-start;
                                font-size: 14px;
                                width: 210mm;
                                min-height: 297mm;
                            }
                            .print-container {
                                transform: scale(0.85);
                                transform-origin: center top;
                                margin: 0 auto 15px auto;
                                width: 210mm;
                                max-width: 210mm;
                                display: block;
                                padding: 0;
                            }
                            .print-container:first-child {
                                margin-bottom: 40px;
                            }
                            /* Print-specific font sizes */
                            .print-container .company-name {
                                font-size: 28px !important;
                                ${user.company_id === 40 ? 'font-family: Bookman Old Style !important; color: #890015 !important;' : ''}
                            }
                            .print-container .company-address {
                                font-size: 16px !important;
                            }
                            .print-container .receipt-title {
                                font-size: 22px !important;
                                ${user.company_id === 40 ? 'font-family: Bookman Old Style !important; color: #890015 !important;' : ''}
                            }
                            .print-container .info-label,
                            .print-container .info-value {
                                font-size: 14px !important;
                            }
                            .print-container .receipt-number {
                                font-size: 18px !important;
                            }
                            .print-container .fees-table th,
                            .print-container .fees-table td {
                                font-size: 13px !important;
                            }
                            .print-container .signature-box {
                                font-size: 13px !important;
                            }
                            .print-container .note-section {
                                font-size: 12px !important;
                            }
                            @page {
                                margin: 3mm;
                                size: A4 portrait;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-container">${cleanPrintContents}</div>
                    <div class="print-container">${cleanPrintContents}</div>
                </body>
            </html>
        `);
        
        printWindow.document.close();
        printWindow.focus();
        
        printWindow.onafterprint = () => {
            printWindow.close();
        };
        
        printWindow.print();
    };

    const ReceiptTemplate = () => (
        <div className="print-container">
            <div className="receipt-header">
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <div style={{flex: '0 0 120px'}}>
                        <img
                            src={getImageUrl(companylogo)}
                            alt="Company Logo"
                            style={{width: '100px', height: '80px', objectFit: 'contain'}}
                        />
                    </div>
                    <div className="company-info" style={{flex: '1'}}>
                        <div className="company-name">{companyname}</div>
                        <div className="company-address">{companyaddr}</div>
                    </div>
                    <div style={{flex: '0 0 120px', textAlign: 'right'}}>
                        {usersjob[0]['student_data'].photo ? (
                            <img
                                src={getImageUrl(usersjob[0]['student_data'].photo)}
                                alt="Student Photo"
                                className="student-photo"
                            />
                        ) : (
                            <img src="/dummy.jpg" alt="Student Photo" className="student-photo" />
                        )}
                    </div>
                </div>
            </div>

            <div className="receipt-title">FEE RECEIPT</div>

            <div className="student-info">
                <div className="info-section">
                    <div className="info-row">
                        <span className="info-label">Receipt No:</span>
                        <span className="info-value receipt-number">
                            {isReceipt == 1 && usersjob[0] && usersjob[0]['invoice'] && usersjob[0]['invoice'].receipt_number
                                ? usersjob[0]['invoice'].receipt_number
                                : (usersjob[0] && usersjob[0]['invoice'] && usersjob[0]['invoice'].invoice_id ? usersjob[0]['invoice'].invoice_id : 'N/A')}
                        </span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">Date:</span>
                        <span className="info-value">
                            {usersjob[0].alt_date
                                ? moment(usersjob[0].alt_date).format("DD-MM-YYYY")
                                : moment(usersjob[0].created_at).format("DD-MM-YYYY")
                            }
                        </span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">Institution:</span>
                        <span className="info-value">{usersjob[0]['annual_data'].head || 'N/A'}</span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">Adm No:</span>
                        <span className="info-value">{usersjob[0].adm_no || 'N/A'}</span>
                    </div>
                </div>
                <div className="info-section">
                    <div className="info-row">
                        <span className="info-label">Name:</span>
                        <span className="info-value">{usersjob[0].first_name || ''} {usersjob[0].last_name || ''}</span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">Course:</span>
                        <span className="info-value">{usersjob[0].class || 'N/A'}</span>
                    </div>
                    {!hideSectionOnReceipt && (
                        <div className="info-row">
                            <span className="info-label">Section:</span>
                            <span className="info-value">{usersjob[0].dev || 'N/A'}</span>
                        </div>
                    )}
                </div>
            </div>

            <table className="fees-table">
                <thead>
                    <tr>
                        <th>SL No</th>
                        <th>Year</th>
                        <th>Fees Type</th>
                        <th>Mode</th>
                        <th>Reference</th>
                        <th>Amount Paid</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{textAlign: 'center'}}>1</td>
                        <td>{usersjob[0].fees_name.ext_2}</td>
                        <td>{usersjob[0].fees_name.name}</td>
                        <td>
                            {usersjob[0].ext_1 === "Agent" ? "" : usersjob[0].ext_1}
                            {usersjob[0]['agent_data']?.name && (
                                <span style={{background: '#007bff', color: 'white', padding: '2px 6px', borderRadius: '3px', marginLeft: '5px', fontSize: '12px'}}>
                                    {usersjob[0]['agent_data'].name}
                                </span>
                            )}
                        </td>
                        <td>{usersjob[0].ext_2}</td>
                        <td style={{textAlign: 'right'}}>{parseFloat(usersjob[0].amount).toLocaleString()}</td>
                    </tr>
                    <tr className="total-row">
                        <td colSpan="5" style={{textAlign: 'right'}}>TOTAL AMOUNT</td>
                        <td style={{textAlign: 'right'}}>{parseFloat(usersjob[0].amount).toLocaleString()}</td>
                    </tr>
                </tbody>
            </table>

            {(() => {
                // Use the calculated totals from feeData if available, otherwise fall back to annual_data
                let dueAmount = 0;
                
                if (feeData.length > 0) {
                    // Use the calculated totals from our fee data
                    dueAmount = totalDue;
                } else if (usersjob[0] && usersjob[0]['annual_data']) {
                    // Fall back to the original calculation using annual_data
                    const totalAmount = parseFloat(usersjob[0]['annual_data'].amount) || 0;
                    const paidAmount = parseFloat(usersjob[0]['annual_data'].ext_6) || 0;
                    dueAmount = totalAmount - paidAmount;
                }
                
                return (
                    <div style={{
                        marginTop: '15px',
                        padding: '10px 15px',
                        background: '#f8f9fa',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px',
                        fontSize: '14px',
                        color: '#495057',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center'
                    }}>
                        <span style={{
                            fontStyle: 'italic',
                            marginRight: '10px'
                        }}>
                            Provisional balance due (subject to change):
                        </span>
                        <span>
                            ₹{dueAmount <= 0 ? '0' : dueAmount.toLocaleString()}
                        </span>
                    </div>
                );
            })()}

            <div className="signature-section">
                <div className="signature-box">
                    <div>{usersjob[0]?.user_name?.name ?? ""} {usersjob[0]?.user_name?.last_name ?? ""}</div>
                    <div className="signature-line"></div>
                    <div>Received by</div>
                </div>
                <div className="signature-box">
                    <div style={{height: '20px'}}></div>
                    <div className="signature-line"></div>
                    <div>&nbsp;</div>
                </div>
            </div>

            <div className="note-section">
                <strong>Note:</strong> Please retain this receipt for future reference. The fee paid is non-refundable and non-transferable.
            </div>
        </div>
    );

    return (
        <>
            <div dangerouslySetInnerHTML={{__html: printStyles}} />
            
            {(!usersjob || usersjob.length === 0) ? (
                <div className="alert alert-warning mt-2" role="alert">
                    This payment has been deleted
                    <span className="badge bg-success text-white ms-2">Receipt No: {num}</span>
                </div>
            ) : (
                <div>
                    <div className="print-buttons">
                        <button className="print-btn" onClick={handlePrint}>
                            Print Two Copies
                        </button>
                        <button className="print-btn" onClick={handlePrintSecond}>
                            Print One Copy
                        </button>
                        <button className="print-btn" onClick={handlePrintInOne}>
                            Print Two Copies in One Page
                        </button>
                        <button className="print-btn" onClick={handlePrintTwoWithoutDue}>
                            Two Copy without Due
                        </button>
                    </div>

                    <ReceiptTemplate />
                    
                    <div id="second" style={{display: 'none'}}>
                        <ReceiptTemplate />
                    </div>
                </div>
            )}
        </>
    );
}